"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Import Vendors
 */
require("lazysizes");
/**
 * Import Functions
 */
const global_1 = require("./functions/global");
const scrollHeader_1 = require("./functions/scrollHeader");
const videoModal_1 = require("./functions/videoModal");
const mobilePanel_1 = require("./functions/mobilePanel");
const tooltips_1 = require("./functions/tooltips");
const tabs_1 = require("./functions/tabs");
const ajaxFilter_1 = require("./functions/ajaxFilter");
const addonControls_1 = require("./functions/addonControls");
const carousels_1 = require("./functions/carousels");
const forms_1 = require("./functions/forms");
const wrapperLinks_1 = require("./functions/wrapperLinks");
const animateIn_1 = require("./functions/animateIn");
const accordion_1 = require("./functions/accordion");
const wooCommerce_1 = require("./functions/wooCommerce");
const distributorMap_1 = require("./functions/distributorMap");
const drawerButton_1 = require("./functions/drawerButton");
const quantity_1 = require("./functions/quantity");
/**
 * Call Functions
 */
(0, global_1.global)();
(0, global_1.accessibility)();
(0, global_1.copyToClipboard)();
(0, scrollHeader_1.scrollHeader)();
(0, videoModal_1.videoModal)();
// mainMenu()
(0, mobilePanel_1.mobilePanel)();
(0, tabs_1.tabs)();
(0, tooltips_1.tooltips)();
(0, addonControls_1.addonControls)();
(0, forms_1.forms)();
(0, forms_1.inputReactiveLabel)();
(0, forms_1.infieldLabel)();
(0, wrapperLinks_1.wrapperLinks)();
(0, animateIn_1.animateIn)();
// smoothScroll()
(0, accordion_1.accordion)();
(0, global_1.mobileButtonNav)();
(0, carousels_1.carousels)();
(0, wooCommerce_1.wooCommerce)();
(0, drawerButton_1.drawerButton)();
(0, distributorMap_1.distributorMap)();
(0, ajaxFilter_1.ajaxFilter)();
// sticky()
(0, quantity_1.quantity)();
(0, forms_1.conditionalFields)();
(0, forms_1.trackingUrls)();
const read_smore_1 = __importDefault(require("read-smore"));
const readMores = document.querySelectorAll('.js-read-smore');
(0, read_smore_1.default)(readMores).init();
//if jQuery is defined
//@ts-ignore
if (typeof jQuery !== 'undefined') {
    //@ts-ignore
    jQuery(document.body).on('updated_cart_totals', function (event) {
        (0, quantity_1.quantity)();
    });
}
